export const getWorkerAccessLevel = (permissions = {}) => {
  if (
    permissions.canViewAllJobs &&
    permissions.canEditJobs &&
    permissions.canDeleteJobs &&
    permissions.canEditClients
  ) {
    return 'admin';
  }

  if (permissions.canViewAllJobs || permissions.canViewClients || permissions.canViewWorkers) {
    return 'section';
  }

  return 'assigned';
};

export const getWorkerPermissionsFromStorage = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    return JSON.parse(localStorage.getItem('workerPermissions') || '{}');
  } catch {
    return {};
  }
};

/** Dozvole radnika ili partnera iz localStorage (zavisno od userType). */
export const getRolePermissionsFromStorage = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const userType = localStorage.getItem('userType');
  const key = userType === 'partner' ? 'partnerPermissions' : 'workerPermissions';
  try {
    return JSON.parse(localStorage.getItem(key) || '{}');
  } catch {
    return {};
  }
};

export const canUserCreateJobs = (userType, permissions = null) => {
  const effectiveType = userType || (typeof window !== 'undefined' ? localStorage.getItem('userType') : null);
  if (effectiveType === 'company' || !effectiveType) {
    return true;
  }

  const perms = permissions || getWorkerPermissionsFromStorage();
  return !!perms.canEditJobs;
};

export const canUserDeleteJobs = (userType, permissions = null) => {
  const effectiveType = userType || (typeof window !== 'undefined' ? localStorage.getItem('userType') : null);
  if (effectiveType === 'company' || !effectiveType) {
    return true;
  }

  const perms = permissions || getWorkerPermissionsFromStorage();
  return !!perms.canDeleteJobs;
};

export const getSchedulerAudience = (userType, permissions = null) => {
  const effectiveType = userType || (typeof window !== 'undefined' ? localStorage.getItem('userType') : null);
  if (effectiveType === 'company' || !effectiveType) {
    return 'company';
  }

  const perms = permissions || getWorkerPermissionsFromStorage();
  if ((effectiveType === 'worker' || effectiveType === 'partner') && perms.canViewAllJobs) {
    return 'company';
  }

  return effectiveType === 'worker' || effectiveType === 'partner' ? 'worker' : 'company';
};

const ROLE_TRANSLATION_KEYS = {
  owner: 'profile.roleOwner',
  admin: 'profile.roleAdmin',
  worker: 'profile.roleWorker',
  coordinator: 'profile.roleCoordinator',
  superadmin: 'profile.roleSuperAdmin',
  assigned: 'profile.roleAccessAssigned',
  section: 'profile.roleAccessSection',
};

export const getProfileRoleLabel = (t, role) => {
  const translationKey = ROLE_TRANSLATION_KEYS[role];
  if (translationKey) {
    return t(translationKey);
  }

  return role || '—';
};

export const getWorkerProfileRole = (worker = {}) => {
  if (worker.role === 'coordinator') {
    return 'coordinator';
  }

  return getWorkerAccessLevel(worker.permissions);
};

/** Radnik sa „potpun pristup (kao admin)” — isti uvid kao vlasnik kompanije. */
export const hasWorkerFullAdminAccess = (permissions = null) => {
  const perms = permissions ?? getRolePermissionsFromStorage();
  return getWorkerAccessLevel(perms) === 'admin';
};

/** Da li korisnik vidi kontrolnu tablu sa statistikama kompanije (prihod, klijenti, …). */
export const canViewCompanyDashboard = (userType, permissions = null) => {
  if (!userType || userType === 'company') return true;
  if (userType === 'worker' || userType === 'partner') {
    return hasWorkerFullAdminAccess(permissions);
  }
  return false;
};